import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DodoMatComponentsCommonModule } from "./dodo-mat-components-common.module";
import { DodoCtaButtonComponent } from "./buttons/dodo-cta-button/dodo-cta-button.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material-module/material.module";
import { TealiumModule } from "../../tealium/tealium.module";
import { RouterModule } from "@angular/router";

const components = [DodoCtaButtonComponent];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		DodoMatComponentsCommonModule,
		TealiumModule,
	],
	declarations: [...components],
	exports: [...components, DodoMatComponentsCommonModule],
})
export class DodoMatComponentsModule {}
